import { useState, useEffect } from "react";
import { Button, Checkbox, Col, DatePicker, Form, Input, Modal, Row, TimePicker, notification } from "antd";
import dayjs from "dayjs";
import { bookingService } from "../../../services";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import MaterialLikeTimePicker from "../../../components/MaterialLikeTimePicker";

export default function ScheduleForm({ visible, onClose, editData, setRefresh }) {
  const [form] = Form.useForm();
  const [appointmentActive, setAppointmentActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const isEditMode = editData?.id !== undefined;

  useEffect(() => {
    if (editData) {
      setAppointmentActive(editData?.isActive === 1 ? true : false);
      form.setFieldsValue({
        date: dayjs(editData.date).tz(),
        start_time: dayjs(editData?.start_time, "HH:mm:ss").tz(),
        end_time: dayjs(editData?.end_time, "HH:mm:ss").tz(),
        isActive: appointmentActive,
        allowed_appointments: editData.allowed_appointments
      });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const data = {
      ...values,
      date: dayjs(values.date).tz().format("YYYY-MM-DD"),
      start_time: values.start_time.format("HH:mm:ss"),
      end_time: values.end_time.format("HH:mm:ss"),
      isActive: appointmentActive ? 1 : 0,
    };

    const response = isEditMode ? await bookingService.updatebooking(editData?.id, data) : await bookingService.addbooking(data);

    setLoading(false);
    if (response.success) {
      setRefresh(true)
      notification.success({
        message: "Success",
        description: isEditMode
          ? "Booking updated successfully!"
          : "Booking added successfully",
        placement: "topRight",
      });
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
    handleClose();
  };

  return (
    <div>
      <Modal
        title={
          <div style={{ width: "100%" }}>
            {editData ? "Edit Booking Schedule" : "Add Booking Schedule"}
          </div>
        }
        open={visible}
        onCancel={handleClose}
        footer={null}
        closable={true}
        width={600}
        style={{ padding: "15px" }}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="date"
                rules={[{ required: true, message: "Please select a date" }]}
              >
                <MaterialLikeDatePicker
                  label="Date"
                  value={form.getFieldValue("date")}
                  onChange={(date) => form.setFieldValue("date", date)}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="start_time"
                rules={[
                  { required: true, message: "Please select a start time" },
                ]}
              >
                <MaterialLikeTimePicker
                  label="Start time"
                  value={form.getFieldValue("start_time")}
                  onChange={(val) => form.setFieldValue("start_time", val)}
                  required
                />
                {/* <TimePicker use12Hours minuteStep={30} style={{ width: "100%" }} format="hh:mm A" needConfirm={false} /> */}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="end_time"
                rules={[
                  { required: true, message: "Please select an end time" },
                ]}
              >
                <MaterialLikeTimePicker
                  label="End time"
                  value={form.getFieldValue("end_time")}
                  onChange={(val) => form.setFieldValue("end_time", val)}
                  required
                />
                {/* <TimePicker use12Hours minuteStep={30} style={{ width: "100%" }} format="hh:mm A" needConfirm={false} /> */}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="allowed_appointments"
                rules={[
                  {
                    required: true,
                    message: "Please enter the number of allowed appointments",
                  },
                ]}
              >
                <MaterialLikeInput
                  label="Allowed appointments"
                  value={form.getFieldValue("allowed_appointments")}
                  onChange={(e) => form.setFieldValue("allowed_appointments", e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Checkbox
              checked={appointmentActive}
              onChange={(e) => setAppointmentActive(e.target.checked ? 1 : 0)}
              label="Active"
              name="isActive"
            >
              Is Active
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "60%", textAlign: "center" }}
                loading={loading}
              >
                {editData ? " Update Booking Schedule" : "Add Booking Schedule"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
